import classNames from 'classnames';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';

import { useStores } from '../../../../../stores/useStores';
import { useWidgetAdaptiveText } from '../../../hooks';

import styles from './FreeSpinsWidgetTimer.module.scss';

interface FreeSpinsWidgetTimerProps {
  eventId: string;
  className?: string;
  extended?: boolean;
}

function FreeSpinsWidgetTimerComponent(props: FreeSpinsWidgetTimerProps) {
  const { eventId, className, extended } = props;
  const { userFreeSpinsStore } = useStores();
  const { t } = useTranslation();
  const timer = userFreeSpinsStore.getFreeSpinTimerFormatted(eventId, t);
  const { textRef } = useWidgetAdaptiveText({ padding: 4 });

  return (
    <div className={classNames(extended ? styles.containerExtended : styles.container, className)}>
      <span ref={textRef} className={extended ? styles.textExtended : styles.text}>
        {timer}
      </span>
    </div>
  );
}

export const FreeSpinsWidgetTimer = observer(FreeSpinsWidgetTimerComponent);
